import { useEffect } from "react";

/**
 * Markeert <main> met data-ad-ready="true" zodra de eigen content van de pagina
 * gerenderd is. AdSenseLoader laadt alleen als dit attribuut aanwezig is.
 * Roep aan met ready=false tijdens loading/error/lege data/NotFound.
 */
export const useAdReady = (ready: boolean = true) => {
  useEffect(() => {
    if (!ready) return;
    const main = document.querySelector("main");
    if (!main) return;
    main.setAttribute("data-ad-ready", "true");
    return () => main.removeAttribute("data-ad-ready");
  }, [ready]);
};
